import React from 'react';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import GavelIcon from '@mui/icons-material/Gavel';
import GroupIcon from '@mui/icons-material/Group';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import SettingsIcon from '@mui/icons-material/Settings';
import ShieldIcon from '@mui/icons-material/Shield';

import type { BaseMenuItemConfig, PrimaryMenuItemConfig } from '@/types';
import { ROUTES } from './routes.constants';

export const PRIMARY_MENU_ITEMS: readonly PrimaryMenuItemConfig[] = [
  {
    label: 'nav.portfolio',
    path: ROUTES.PORTFOLIO,
    icon: <AccountBalanceWalletIcon sx={{ fontSize: '1.25rem' }} />,
  },
  {
    label: 'nav.streaks',
    path: ROUTES.STREAKS,
    icon: <LocalFireDepartmentIcon sx={{ fontSize: '1.25rem' }} />,
  },
  {
    label: 'nav.leaderboard',
    path: ROUTES.LEADERBOARD,
    icon: <EmojiEventsIcon sx={{ fontSize: '1.25rem' }} />,
  },
  {
    label: 'nav.referrals',
    path: ROUTES.REFERRALS,
    icon: <GroupIcon sx={{ fontSize: '1.25rem' }} />,
  },
  {
    label: 'nav.bookmarks',
    path: ROUTES.BOOKMARKS,
    icon: <BookmarkIcon sx={{ fontSize: '1.25rem' }} />,
  },
  {
    label: 'nav.settings',
    path: ROUTES.PROFILE,
    icon: <SettingsIcon sx={{ fontSize: '1.25rem' }} />,
  },
];

export const SECONDARY_MENU_ITEMS: readonly BaseMenuItemConfig[] = [
  {
    label: 'nav.privacy',
    path: ROUTES.PRIVACY,
    icon: <ShieldIcon sx={{ fontSize: '1.25rem' }} />,
  },
  {
    label: 'nav.termsOfUse',
    path: ROUTES.TERMS,
    icon: <GavelIcon sx={{ fontSize: '1.25rem' }} />,
  },
];

export const FOOTER_MENU_LINKS: readonly BaseMenuItemConfig[] = [
  { label: 'nav.privacy', path: ROUTES.PRIVACY },
  { label: 'nav.termsOfUse', path: ROUTES.TERMS },
];
